var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_744_22566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.24989 9H1.74993C0.784969 9 0 8.11691 0 7.03113V1.96867C0 0.883088 0.784969 0 1.74993 0H9.24989C10.215 0 11 0.883088 11 1.96867V7.03113C11 8.11691 10.215 9 9.24989 9ZM2.24994 1.96867C2.11206 1.96867 2 2.09473 2 2.24985V6.74974C2 6.90506 2.11206 7.03113 2.24994 7.03113H8.74988C8.88794 7.03113 9 6.90506 9 6.74974V2.21851C9 2.0634 8.88794 1.96867 8.74988 1.96867H2.24994Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24989 24H1.74993C0.784969 24 0 23.215 0 22.2501V11.7501C0 10.785 0.784969 10 1.74993 10H9.24989C10.215 10 11 10.785 11 11.7501V22.2501C11 23.215 10.215 24 9.24989 24ZM2.20541 12C2.06753 12 1.95547 12.1121 1.95547 12.2501V21.7501C1.95547 21.8879 2.06753 22 2.20541 22H8.74988C8.88794 22 9 21.8879 9 21.7501V12.2501C9 12.1121 8.88794 12 8.74988 12H2.20541Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2501 24H14.7501C13.785 24 13 23.1169 13 22.0313V16.9689C13 15.8831 13.785 15 14.7501 15H22.2501C23.215 15 24 15.8831 24 16.9689V22.0313C24 23.1169 23.215 24 22.2501 24ZM15.2501 16.9689C15.1121 16.9689 15 17.0949 15 17.2503V21.7502C15 21.9053 15.1121 22.0313 15.2501 22.0313H21.7501C21.8879 22.0313 22 21.9053 22 21.7502V17.2503C22 17.0949 21.8879 16.9689 21.7501 16.9689H15.2501Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2501 14H14.7501C13.785 14 13 13.215 13 12.2499V1.74993C13 0.78497 13.785 0 14.7501 0H22.2501C23.215 0 24 0.78497 24 1.74993V12.2499C24 13.215 23.215 14 22.2501 14ZM15.2501 2.00612C15.1121 2.00612 15 2.11819 15 2.25606V11.7499C15 11.8879 15.1121 12 15.2501 12H21.7501C21.8879 12 22 11.8879 22 11.7499V2.25606C22 2.11819 21.8879 2.00612 21.7501 2.00612H15.2501Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_744_22566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.87d625bcabb4e39189d92a6189d070b9.svg";
export { ForwardRef as ReactComponent };